export default __webpack_public_path__ + "static/media/unmute.02d327c0.svg";